import React, { useEffect, useRef } from "react";
import anime from "animejs";
import Footer from "../Footer";
import Header from "../Header";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { apiCall, mediaUrl } from "../util";
import { useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { logofloating } from "../Image";
import { setTopSpaceHeight } from "../custom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DepartmentPage = () => {
  const location = useLocation();
  const departmentId = location.state?.departmentId;
  const titleRef = useRef(null);
  const [data, setData] = useState();
  const [blog, setBlog] = useState([]);
  const [doctor, setDoctor] = useState([]);
  const [departmentPage, setDepartmentPage] = useState([]);
  const [video, setVideo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 4;
  const [activeTab, setActiveTab] = useState("");
  // Calculate total pages
  const totalPages = Math.ceil(blog.length / blogsPerPage);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  // Get blogs for the current page
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blog.slice(indexOfFirstBlog, indexOfLastBlog);
  const doctorListRef = useRef(null);
  useEffect(() => {
    if (doctor.length > 0) {
      setLoaded(true);
      if (doctorListRef.current) {
        anime({
          targets: doctorListRef.current.children,
          opacity: [0, 1],
          translateY: [50, 0],
          duration: 1200,
          delay: anime.stagger(400),
          easing: "easeOutQuad",
        });
      }
    }
  }, [doctor]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      // Reset active tab before fetching new data
      setLoading(true);

      try {
        const result = await axios.post(apiCall + "department/view", {
          id: departmentId,
        });
        setData(result.data);

        const response = await axios.post(apiCall + "blog/getByDepartment", {
          departmentid: departmentId,
        });
        setBlog(response.data);

        const doctorResponse = await axios.post(
          apiCall + "doctor/doctorByDepartment",
          {
            department_id: departmentId,
          }
        );
        const sortedDoctors = doctorResponse.data.sort((a, b) => {
          if (a.priority === null) return 1; // Move null values to the end
          if (b.priority === null) return -1; // Move null values to the end
          return a.priority - b.priority; // Sort in ascending order
        });
        setDoctor(sortedDoctors);
        // console.log(sortedDoctors)

        const departmentPageResponse = await axios.post(
          apiCall + "department_page/getByDepartment",
          {
            departmentid: departmentId,
          }
        );
        setDepartmentPage(departmentPageResponse.data);

        const videosResponse = await axios.post(
          apiCall + "department_video/getByDepartment",
          {
            departmentid: departmentId,
          }
        );
        setVideo(videosResponse.data);

        // Set active tab based on the fetched data
        if (sortedDoctors.length > 0) {
          setActiveTab("tab_eight1");
        } else if (departmentPageResponse.data.length > 0) {
          setActiveTab("tab_eight2");
        } else if (videosResponse.data.length > 0) {
          setActiveTab("tab_eight3");
        } else if (currentBlogs.length > 0) {
          setActiveTab("tab_eight4");
        } else {
          setActiveTab(""); // No active tab if all are empty
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchDepartmentData();
  }, [departmentId]);

  useEffect(() => {
    if (typeof setTopSpaceHeight === "function") {
      setTopSpaceHeight();
    }
  }, []);

  useEffect(() => {
    if (titleRef.current) {
      anime({
        targets: titleRef.current.children,
        opacity: [0, 1],
        translateX: [-50, 0],
        duration: 800,
        delay: anime.stagger(300),
        easing: "easeOutQuad",
      });
    }
  }, []);

  return (
    <>
      <Header />

      <section
        className="top-space-margin position-relative pt-60px pb-60px page-title-big-typography bg-sg-light-gradient -bg-base-color-light"
        // style={{ marginTop: "170.984px" }}
      >
        <img src={logofloating} className="floating-logo" alt="floating-logo" />
        <div className="container">
          <div className="row -extra-very-small-screen align-items-center">
            <div
              className="col-lg-6 col-sm-8 position-relative page-title-extra-small"
              ref={titleRef}
            >
              <h1 className="mb-20px xs-mb-20px text-dark-gray text-shadow-medium">
                <span className="w-30px h-2px bg-base-color d-inline-block align-middle position-relative top-minus-2px me-10px"></span>
                Our Departments
              </h1>
              <h4 className="text-dark-gray text-shadow-medium fw-bold ls-minus-2px mb-0">
                <span className="text-gradient-sg-red-purple">
                  {data?.name || <Skeleton width={"100%"} height={"100%"} />}
                </span>
              </h4>
            </div>
          </div>
        </div>
      </section>

      <section className="sg-li bg-white half-section -pb-0 text-dark-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="text-justify">
                {data?.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data?.description,
                    }}
                  />
                ) : (
                  <>
                    <Skeleton height={90} />
                    <Skeleton height={90} />
                    <Skeleton height={90} />
                    <Skeleton height={90} />
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-5">
              {data?.image ? (
                <img
                  src={`${mediaUrl}/${data.image}`}
                  alt="Healthcare Story"
                  className="sg-img-radius h-100 object-fit-cover"
                  height="100%"
                  width="100%"
                />
              ) : (
                <Skeleton
                  height={"100%"}
                  width={"100%"}
                  style={{
                    borderRadius: "0px 60px 0px 60px",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {doctor.length > 0 ||
      departmentPage.length > 0 ||
      video.length > 0 ||
      currentBlogs.length > 0 ? (
        <section className="bg-white -bg-sg-light-gradient pb-0 pt-0">
          <div className="tab-style-08 border-bottom border-color-extra-medium-gray bg-white box-shadow-quadruple-large">
            <div className="container">
              <ul className="nav nav-tabs border-0 fw-500 fs-18 text-center">
                {loading ? (
                  <>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                  </>
                ) : (
                  <>
                    {doctor.length > 0 && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight1" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight1")}
                          style={{ width: "100%" }}
                        >
                          Our Doctors
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {departmentPage.length > 0 && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight2" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight2")}
                          style={{ width: "100%" }}
                        >
                          Treatments and Procedures
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {video.length > 0 && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight3" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight3")}
                          style={{ width: "100%" }}
                        >
                          Videos
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {currentBlogs.length > 0 && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight4" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight4")}
                          style={{ width: "100%" }}
                        >
                          Articles & Blogs
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
          <div className="container">
            <div className="row row pt-4 pb-4">
              <div className="col-12 tab-style-08">
                <div className="tab-content" ref={doctorListRef}>
                  {loading ? (
                    <div className="row">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <div className="col-12 col-md-4 mb-4" key={index}>
                          <div className="card skeleton-card">
                            {/* Skeleton for the image */}
                            <div
                              className="skeleton-image"
                              style={{
                                height: "200px",
                                backgroundColor: "#e0e0e0",
                              }}
                            >
                              <Skeleton height="100%" />
                            </div>
                            <div className="card-body">
                              <h5 className="fw-600 fw-bold">
                                <Skeleton width="80%" height={30} />
                              </h5>
                              <p>
                                <Skeleton width="100%" height={20} />
                              </p>
                              <p>
                                <Skeleton width="100%" height={20} />
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      {doctor.length > 0 && (
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tab_eight1" ? "show active" : ""
                          }`}
                          id="tab_eight1"
                        >
                          {/* Render Doctors Content */}
                          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 justify-content-start gy-4">
                            {loaded ? (
                              doctor.map((doc, index) => (
                                <div className="col doctor-card" key={index}>
                                  <div className="d-flex flex-column box-shadow-quadruple-large box-shadow-quadruple-large-hover services-box-style-03 last-paragraph-no-margin overflow-hidden border-radius-4px h-100">
                                    <div>
                                      <Link
                                        to={`/doctorprofile/${doc.slug}`}
                                        state={{ doctorId: doc.id }}
                                      >
                                        <img
                                          src={
                                            doc.image
                                              ? `${mediaUrl}/${doc.image}`
                                              : "/placeholder.jpg"
                                          }
                                          alt={doc.name || "Doctor Image"}
                                          className="doctor-image"
                                        />
                                      </Link>
                                    </div>
                                    <div className="d-flex flex-column bg-white h-100 justify-content-between ps-20px pe-20px pt-20px pb-20px text-left">
                                      <div>
                                        <Link
                                          to={`/doctorprofile/${doc.slug}`}
                                          state={{ doctorId: doc.id }}
                                          className="d-inline-block fs-16 fw-700 text-dark text-dark-gray-hover mb-0"
                                        >
                                          {doc.name || "No Name"}
                                        </Link>
                                        <p className="m-0 lh-1 fw-500 mb-5px text-gray fs-14">
                                          {doc.department?.name ||
                                            "No department"}
                                        </p>
                                        <p className="m-0 lh-1 fw-600 text-base-color fs-14">
                                          {doc.designation?.designation ||
                                            "No Designation"}
                                        </p>
                                      </div>
                                      <div className="mt-20px justify-content-end">
                                        {doc.viewProfile ? (
                                          <Link
                                            to={`/doctorprofile/${doc.slug}`}
                                            state={{ doctorId: doc.id }}
                                            className="btn rounded btn-sm w-100 btn-switch-text btn-round-edge btn-transparent-light-gray d-table d-lg-inline-block mb-5px md-mx-auto"
                                          >
                                            <span>
                                              <span
                                                className="btn-double-text"
                                                data-text="View Profile"
                                              >
                                                View Profile
                                              </span>
                                            </span>
                                          </Link>
                                        ) : null}
                                        {doc.hasAppointment ? (
                                          <a
                                            href={`#appointment/${doc.id}`}
                                            className="btn rounded btn-sm w-100 btn-switch-text btn-base-color left-icon d-table d-lg-inline-block lg-mb-15px md-mx-auto"
                                          >
                                            <span>
                                              <i className="fa-solid fa-calendar-alt"></i>
                                              <span
                                                className="btn-double-text"
                                                data-text="Book an Appointment"
                                              >
                                                Book an Appointment
                                              </span>
                                            </span>
                                          </a>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <Skeleton width="100%" height={20} />
                            )}
                          </div>
                        </div>
                      )}

                      {departmentPage.length > 0 && (
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tab_eight2" ? "show active" : ""
                          }`}
                          id="tab_eight2"
                        >
                          {/* Render Treatments and Procedures Content */}
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-start text-dark-gray">
                              <h6 className="fw-600">
                                {departmentPage[0]?.title}
                              </h6>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: departmentPage[0]?.description,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {video.length > 0 && (
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tab_eight3" ? "show active" : ""
                          }`}
                          id="tab_eight3"
                        >
                          {/* Render Videos Content */}
                          <div className="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-3 align-items-center justify-content-center gy-2 gy-lg-4">
                            {video.map((item) => {
                              const videoId = item.video
                                .split("v=")[1]
                                ?.split("&")[0];
                              return (
                                <div key={item.id} className="col">
                                  <div className="w-100 h-100">
                                    <iframe
                                      width="100%"
                                      height="300"
                                      src={`https://www.youtube.com/embed/${videoId}?autoplay=0&mute=1&rel=0&showinfo=0`}
                                      allowFullScreen
                                    ></iframe>
                                    <div className="text-dark-gray fs-18 fw-600 mt-6">
                                      {item.title}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {currentBlogs.length > 0 && (
                        <>
                          <div
                            className={`tab-pane fade ${
                              activeTab === "tab_eight4" ? "show active" : ""
                            }`}
                            id="tab_eight4"
                          >
                            {/* Render Blogs Content */}
                            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 blog-grid g-4">
                              {currentBlogs.map((blogItem) => (
                                <div className="col" key={blogItem.id}>
                                  <div className="card border-0 border-radius-4px box-shadow-extra-large box-shadow-extra-large-hover">
                                    <div className="blog-image">
                                      <a
                                        href={`/blog/${blogItem.slug}`}
                                        className="d-block"
                                      >
                                        <img
                                          src={`${mediaUrl}/${blogItem.thumbnail}`}
                                          alt={blogItem.title}
                                          style={{
                                            width: "100%",
                                            height: "250px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </a>
                                    </div>
                                    <div className="card-body p-12">
                                      <a
                                        href={`/blog/${blogItem.slug}`}
                                        className="card-title mb-15px fw-600 fs-17 lh-26 text-dark-gray text-dark-gray-hover d-inline-block"
                                      >
                                        <p
                                          className="line-clamp-2"
                                          style={{ height: "50px" }}
                                        >
                                          {blogItem.title}
                                        </p>
                                      </a>
                                      <p
                                        className="line-clamp-2"
                                        style={{ height: "60px" }}
                                      >
                                        {blogItem.metadescription}
                                      </p>
                                      <div className="author d-flex justify-content-center align-items-center position-relative overflow-hidden fs-14 text-uppercase">
                                        <div className="me-auto">
                                          <span className="blog-date fw-500 d-inline-block">
                                            {new Date(
                                              blogItem.created_at
                                            ).toLocaleDateString()}
                                          </span>
                                          <div className="d-inline-block author-name">
                                            By{" "}
                                            <a
                                              href="#"
                                              className="text-dark-gray text-dark-gray-hover text-decoration-line-bottom fw-600"
                                            >
                                              {blogItem.author}
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            {/* pagination */}
                            <div className="row">
                              <div className="col-12 mt-4 d-flex justify-content-center">
                                <ul className="pagination pagination-style-01 fs-13 fw-500 mb-0">
                                  {/* Left Arrow (Disable if on First Page) */}
                                  <li
                                    className={`page-item ${
                                      currentPage === 1 ? "disabled" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        setCurrentPage(currentPage - 1)
                                      }
                                    >
                                      <i className="feather icon-feather-arrow-left fs-18 d-xs-none"></i>
                                    </button>
                                  </li>

                                  {/* Dynamic Page Numbers */}
                                  {Array.from(
                                    { length: totalPages },
                                    (_, index) => (
                                      <li
                                        className={`page-item ${
                                          index + 1 === currentPage
                                            ? "active"
                                            : ""
                                        }`}
                                        key={index}
                                      >
                                        <button
                                          className="page-link"
                                          onClick={() =>
                                            setCurrentPage(index + 1)
                                          }
                                        >
                                          {index + 1}
                                        </button>
                                      </li>
                                    )
                                  )}

                                  {/* Right Arrow (Disable if on Last Page) */}
                                  <li
                                    className={`page-item ${
                                      currentPage === totalPages
                                        ? "disabled"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        setCurrentPage(currentPage + 1)
                                      }
                                    >
                                      <i className="feather icon-feather-arrow-right fs-18 d-xs-none"></i>
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : null}

      <Footer />
    </>
  );
};

export default DepartmentPage;
